import AddTask from "./AddTask";
import React, { useState, useEffect } from 'react';
import { axiosV2 } from '../../../utils/BasicAuthAPI';
import { Modal } from 'antd';
import moment from "moment";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";


const AddTaskModal = (props) => {
    const [visible, setVisible] = useState(false);
    const [dataLoading, setDataLoading] = useState({ loading: false, loaded: false });
    const [AuditLines, setAuditLines] = useState([]);
    const [AuditType, setAuditType] = useState([]);
    const [AuditUsers, setAuditUsers] = useState([]);
    const [loginError, setLoginError] = useState(false);

    const sendBackData = (editData) => {
        setVisible(false);
        props.modelCloseHandler(editData);
    }

    const handleCancel = () => {
        setVisible(false);
        props.modelCloseHandler(null, props.editData);
    };

    const fetchLine = () => {
        axiosV2.get('mdict', {
            params: {
                typ: "Line",
                subTyp: "Idame"
            }
        }).then(({ data }) => {
            const keys = Object.keys(data["Data"]);
            const resData = keys.map((key) => { return { id: key, name: data["Data"][key] } });
            
            setAuditLines(resData);
            fetchType();
        }).catch(function (error) {
            console.log("Error****: fetch line");
            if(error.response!==undefined)
            {
                if (error.response.status !== 401) {
                    ApiErrorComp(error.response.status);
                  } else {
                    setLoginError(true);
                  }
    
            }
        });
    }
    const fetchType = () => {
        axiosV2.get('mdict', {
            params: {
                typ: "AuditTypes",
                subTyp: "Idame"
            }
        }).then(({ data }) => {
            const resData = data["Data"].map((obj) => { return { id: Object.keys(obj)[0], name: Object.values(obj)[0] } });
            setAuditType(resData);
            fetchUser();
        }).catch(function (error) {
            console.log("Error****: fetch type");
            if(error.response!==undefined)
            {
                if (error.response.status !== 401) {
                    ApiErrorComp(error.response.status);
                  } else {
                    setLoginError(true);
                  }
    
            }
        });
    }

    const fetchUser = () => {
        axiosV2.get('mdict', {
            params: {
                typ: "User",
                subTyp: "Idame"
            }
        }).then(({ data }) => {
            const keys = Object.keys(data["Data"]);
            const resData = keys.map((key) => { return { id: key, name: data["Data"][key] } });
            setAuditUsers(resData);
            setDataLoading({ loading: false, loaded: true });
        }).catch(function (error) {
            console.log("Error****: fetch user");
            if(error.response!==undefined)
            {
                if (error.response.status !== 401) {
                    ApiErrorComp(error.response.status);
                  } else {
                    setLoginError(true);
                  }
    
            }
        });
    }

    useEffect(() => {
        
        if (!dataLoading.loaded && !dataLoading.loading) {
            
            setDataLoading({ ...dataLoading, loading: true });
            fetchLine();
        }

    }, [dataLoading.loading])

    useEffect(() => {
        
        if (props.visible) {
            setVisible(props.visible)
        }
    }, [props]);

    useEffect(() => {

    })
    return (
        <>
        <SessionError visible={loginError} />
        <React.Fragment>


            <Modal
                title={"Add task"}
                open={visible}
                onOk={handleCancel}
                onCancel={handleCancel}
                className={"ThemeModal"}
                width={450}
            >
                <AddTask
                    sendBackData={sendBackData}
                    AuditLines={AuditLines}
                    AuditType={AuditType}
                    AuditUsers={AuditUsers}
                    ClauseData={props.ClauseData}
                    loaded={dataLoading.loaded}
                />


            </Modal>
        </React.Fragment>
       </>
    );
};

export default AddTaskModal;